import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Plano } from '../models/plano.model';

export function campanhaPlanosValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const selecionarTodos = control.get('selecionarTodosPlanos')?.value;
    if (selecionarTodos) {
      return null;
    }

    const planos = control.get('planosAdicionados')?.value as Plano[] | undefined;
    if (planos && planos.length > 0) {
      return null;
    }

    return { planosRequired: true };
  };
}
